import {
  AddPripomienkaApi,
  SaveAdminPripomienka as AddAdminPripomienkaGenerated,
  SavePripomienka as AddPripomienkaGenerated,
} from 'pripomienky-web-ts-axios';
import { AxiosRequestConfig } from 'axios';
import apiConfiguration from './configuration/apiConfiguration';
import { ClientResponse } from '../model/ClientResponse';
import Uuid from '../model/Uuid';
import ClassType, { classTypeToGenerated } from '../model/pripomienka/ClassType';
import SavePripomienka from '../model/pripomienka/SavePripomienka';
import SaveAdminPripomienka from '../model/pripomienka/SaveAdminPripomienka';
import dateToString from '../function/dateToString';
import { stavPripomienkyToGenerated } from '../model/pripomienka/StavPripomienky';
import { povahaPripomienkyToGenerated } from '../model/pripomienka/PovahaPripomienky';
import { pripomienkyPrefixPath } from './configuration/apiConfigurationConstants';

const client = new AddPripomienkaApi(apiConfiguration(pripomienkyPrefixPath));

const map = (pripomienka: SavePripomienka): AddPripomienkaGenerated => ({
  clanok: pripomienka.clanok,
  paragraf: pripomienka.paragraf,
  odsek: pripomienka.odsek,
  celyMaterial: pripomienka.celyMaterial,
  ine: pripomienka.ine,
  textPripomienky: pripomienka.text,
  zasadna: pripomienka.zasadna,
});

const mapAdminPripomienka = (pripomienka: SaveAdminPripomienka): AddAdminPripomienkaGenerated => ({
  pripomienkujuciSubjekt: pripomienka.pripomienkujuciSubjekt ? pripomienka.pripomienkujuciSubjekt.uuid : null,
  pripomienkovatel: pripomienka.pripomienkovatel ? pripomienka.pripomienkovatel.uuid : null,
  datumVytvorenia: dateToString(pripomienka.datumVytvorenia),
  clanok: pripomienka.clanok,
  paragraf: pripomienka.paragraf,
  odsek: pripomienka.odsek,
  celyMaterial: pripomienka.celyMaterial,
  ine: pripomienka.ine,
  textPripomienky: pripomienka.text,
  zasadna: pripomienka.zasadna,
  odoslana: pripomienka.odoslana,
  povahaPripomienky: povahaPripomienkyToGenerated(pripomienka.povahaPripomienky),
  priradeny: pripomienka.priradeny ? pripomienka.priradeny.uuid : null,
  vyhodnotil: pripomienka.vyhodnotil ? pripomienka.vyhodnotil.uuid : null,
  stav: stavPripomienkyToGenerated(pripomienka.stavPripomienky),
  textVyhodnotenia: pripomienka.textVyhodnotenia,
});

export const addPripomienka = async (
  classType: ClassType,
  type: string,
  year: number,
  index: number,
  pripomienka: SavePripomienka,
  options?: AxiosRequestConfig,
):
  Promise<ClientResponse<Uuid>> => {
  const {
    data,
    status,
  } = await client.addPripomienka(
    classTypeToGenerated(classType),
    type,
    year,
    index,
    map(pripomienka),
    options,
  );
  return {
    data: data.uuid,
    responseCode: status,
  };
};

export const addPripomienkaAdmin = async (
  classType: ClassType,
  type: string,
  year: number,
  index: number,
  pripomienka: SaveAdminPripomienka,
  options?: AxiosRequestConfig,
):
  Promise<ClientResponse<void>> => {
  const {
    status,
  } = await client.addPripomienkaAdmin(
    classTypeToGenerated(classType),
    type,
    year,
    index,
    mapAdminPripomienka(pripomienka),
    options,
  );
  return {
    responseCode: status,
  };
};
